module.exports = __webpack_public_path__ + "img/icon_submenu15.786956fb.svg";